// src/plugins/vuetify.js

import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'

import { createVuetify } from 'vuetify'
import { sv } from 'vuetify/locale'

export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#fd8b06',
        },
      },
    },
  },
  locale: {
    locale: 'sv',
    messages: { sv },
  },
  date: {
    locale: {
      sv: 'sv-SE',
    },
  },
})
